import { AccountTypes } from "../../Common/Constant";

export const InsuredRelationshipWithOwnerOptions = [
    { value: "", label: "" },
    { value: "Spouse", label: "Spouse" },
    { value: "Mother", label: "Mother" },
    { value: "Father", label: "Father" },
    { value: "Child", label: "Child" },
    { value: "Brother", label: "Brother" },
    { value: "Sister", label: "Sister" },
    { value: "Grandchild", label: "Grandchild" },
    { value: "Friend", label: "Friend" },
    { value: "Trust", label: "Trustee" },
    { value: "Self", label: "Self" },
    { value: "Other", label: "Other" },
];

export const InsuredRelationshipWithOwnerOptionsForTrust = [
    { value: "", label: "" },
    { value: "Trust", label: "Trustee" },
    { value: "Other", label: "Other" },
];

export const getInsuredRelationshipWithOwnerOptions = (accountType) => {
    return (accountType && accountType.toLowerCase() === AccountTypes.TRUST) ? InsuredRelationshipWithOwnerOptionsForTrust : InsuredRelationshipWithOwnerOptions;
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/InsuredRelationshipWithOwnerOptions.js